import { ServiceRequestPayload, ServiceResponse } from'./types';
import { ApiEndpoints } from '@shared/api/api-endpoints';
import { consumerApiClient, onboardingApiClient } from '@shared/api/clients/apiClientFactory';

export const serviceApis ={

    createBulkServiceRequest: async (data: any): Promise<any> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "cx",
        `bulk-service-request/v1`
      );
      const response = await consumerApiClient.post(url, data);
      return response.data;
    },

    createSingleServiceRequest: async (data: any): Promise<any> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "consumerWeb",
        `service-requests`
      );
      const response = await consumerApiClient.post(url, data);
      return response.data;
    },
   
}

